import { apiFetch } from './utils/api';

export const wealthBalance = {
  get: async () => {
    const options = {
      method: 'GET',
    };

    const url = '/v1/wealth-plan/wealth-balance';

    const { body } = await apiFetch(url, {
      ...options,
    });

    return body;
  },
};
